export default {"src":"/_next/static/media/star.356a45fd.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};